import DomEventHelper from '@/helpers/DomEventHelper';

interface IAreaData {
  id: string;
  height: number;
  priority: number;
  top: number;
}

export default class DomPositioningHelper {
  private static topMarginHeight = 0;
  private static registeredAreas: IAreaData[] = [];

  public static registerArea(priority: number, areaId: string, height: number): void {
    const alreadyRegistered = this.registeredAreas.find(area => area.id === areaId);
    if(alreadyRegistered) {
      const registeredAreaPosition = this.registeredAreas.findIndex(area => area.id === areaId);
      this.topMarginHeight -= alreadyRegistered.height;
      this.topMarginHeight += height;
      this.registeredAreas[registeredAreaPosition] = {
        height,
        id: areaId,
        priority,
        top: 0,
      };
    } else {
      this.topMarginHeight += height;
      this.registeredAreas.push({
        height,
        id: areaId,
        priority,
        top: 0,
      });
    }
    this.calculateAreaPositions();
    DomEventHelper.fireEvent({ name: `rin-top-margin-height-changed` });
  }

  private static calculateAreaPositions():void {
    const sortedAreasByPriority = this.registeredAreas.sort((a, b) => ((a.priority > b.priority) ? 1 : -1));
    let lastTop = 0;
    for(const area of sortedAreasByPriority) {
      area.top = lastTop;
      lastTop += area.height;
    }
  }

  public static setBodyPosition(body: HTMLBodyElement | null) : void {
    if(body) {
      body.style.marginTop = `${this.topMarginHeight}px`;
    }
  }

  public static getAreaTopPosition(areaId: string): number {
    const selectedArea = this.registeredAreas.find(area => area.id === areaId);
    return selectedArea ? selectedArea.top : 0;
  }
}
